export default "__VITE_ASSET__BmxQG9Rb__"